import { useEffect } from 'react';

/**
 * Hook für automatisches Neuladen bei neuer Version
 * Prüft alle 30 Sekunden, ob eine neue Version verfügbar ist
 */
const useVersionCheck = () => {
  useEffect(() => {
    let currentVersion = null;

    const checkVersion = async () => {
      try {
        // Cache-Busting mit Timestamp
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-cache',
          headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache'
          }
        });

        if (!response.ok) return;

        const data = await response.json();

        // Beim ersten Check die aktuelle Version speichern
        if (currentVersion === null) {
          currentVersion = data.version;
          console.log('🔍 Version Check aktiviert:', currentVersion);
          return;
        }

        // Wenn Version sich geändert hat, Seite neu laden
        if (data.version !== currentVersion) {
          console.log('🔄 Neue Version verfügbar! Lade Seite neu...');
          console.log(`Alt: ${currentVersion} → Neu: ${data.version}`);

          // Cache leeren und Seite neu laden
          if ('caches' in window) {
            caches.keys().then(names => {
              names.forEach(name => caches.delete(name));
            });
          }

          // Hard reload ohne Cache
          window.location.reload(true);
        }
      } catch (error) {
        // Netzwerk kurz weg — still ignorieren, kein Spam im Console
        if (!(error instanceof TypeError)) {
          console.error('❌ Version Check Fehler:', error);
        }
      }
    };

    // Initialer Check
    checkVersion();

    // Regelmäßiger Check alle 30 Sekunden
    const interval = setInterval(checkVersion, 30000);

    return () => clearInterval(interval);
  }, []);
};

export default useVersionCheck;
